import { AWHeading} from "@aviwest/ui-kit";
import { FieldArray, Formik, getIn } from "formik";
import PropTypes from "prop-types";
import React, {Component, Fragment} from 'react';
import {Translate, withLocalize} from "react-localize-redux";
import { Alert, Button, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { SETTINGS_OUTPUT_CUSTOM_PATTERN_PREFIX, STATUS_LIVE, STATUS_OFF, STATUS_ON, VIDEO_CARD_TYPE_RIVERMAX } from "../../../../../constants";
import { getAvailableHardwareOutputStandards, getAvailableLostStreamModes, getAvailableVideoCards } from "../../../../../misc/capabilities.selectors";
import { getBasebandPlayerOutputNames } from "../../../../../misc/config.selectors";
import { outputMatchingVideoCard } from "../../../../../utils/global-utils";
import { lostStreamModePropTypes } from "../../../../../utils/models-prop-types";
import HelpLayout from "../../../../common/help-layout";
import CustomPatternForm from "../../../settings/custom-pattern/custom-pattern-form";
import { connect } from 'react-redux';
import { isEmptyString } from '../../../../../utils/string-utils';


const propTypes = {
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    forbiddenNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    outputId: PropTypes.string.isRequired,
    outputStatus: PropTypes.oneOf([STATUS_LIVE, STATUS_OFF, STATUS_ON]),
    config: PropTypes.shape({
      name: PropTypes.string.isRequired,
      outputStandard: PropTypes.string.isRequired,
      sameAsInput: PropTypes.bool.isRequired,
      lostStreamMode: PropTypes.number.isRequired,
      lostPatternMode: PropTypes.number.isRequired,
      enableDisplayName: PropTypes.bool,
      enableMulticast: PropTypes.bool,
      ttl: PropTypes.number,
      destinations: PropTypes.string,
      video: PropTypes.shape({
        redundancy: PropTypes.bool,
      })
    }),
    lostStreamModes: PropTypes.arrayOf(lostStreamModePropTypes).isRequired,
    outputStandards: PropTypes.arrayOf(PropTypes.string).isRequired,
    localIps: PropTypes.arrayOf(PropTypes.string),
    licenceStatus: PropTypes.bool,
}

const PORT_MIN = 1024;
const PORT_MAX = 65535;
const CUSTOM_PATTERN_VALUE = 3;

class SMPTE2110Form extends Component {

    constructor(props) {
        super(props);
    
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCustomPattern = this.handleCustomPattern.bind(this);
    
        this.state = {
          customPatternFormVisible: false
        }
      }

      componentDidMount(){
        if(this.props.config.lostStreamMode === CUSTOM_PATTERN_VALUE || this.props.config.lostPatternMode === CUSTOM_PATTERN_VALUE){
          this.handleCustomPattern(true);
        }
      }
    
      handleCustomPattern(display){
        this.setState({
          customPatternFormVisible: display
        });
      }
    
      handleSubmit(values, {resetForm} ) {
        const data = {
          ...values,
          lostStreamMode: parseInt(values.lostStreamMode),
          lostPatternMode: parseInt(values.lostPatternMode)
        };
        values.pTime = parseInt(values.pTime, 10);
          data.video = {redundancy: values.redundancyVideo,
                        ttl: values.ttlVideo,
                        multicast: values.multicastVideo,
                        multicast2: values.multicastVideo2,
                        destinations: values.destinationsVideo.map(destination => `${destination.host}:${destination.port}`).join(','),
                        destinations2: values.destinationsVideo2.map(destination => `${destination.host}:${destination.port}`).join(','),
                        iface: values.ifaceVideo,
                        iface2: values.ifaceVideo2,
                        rtpPayLoadType: values.rtpPayLoadTypeVideo
                      }
          values.sameAsVideo ? data.audio = {...data.video, sameAsVideo:values.sameAsVideo, rtpPayLoadType: values.rtpPayLoadTypeAudio, pTime: values.pTime} :
           data.audio = {redundancy: values.redundancyAudio,
                        ttl: values.ttlAudio,
                        multicast: values.multicastAudio,
                        multicast2: values.multicastAudio2,
                        destinations: values.destinationsAudio.map(destination => `${destination.host}:${destination.port}`).join(','),
                        destinations2: values.destinationsAudio2.map(destination => `${destination.host}:${destination.port}`).join(','),
                        iface: values.ifaceAudio,
                        iface2: values.ifaceAudio2,
                        sameAsVideo: values.sameAsVideo,
                        rtpPayLoadType: values.rtpPayLoadTypeAudio,
                        pTime: values.pTime
                      };
            values.sameAsVideoAnc ? data.anc = {...data.video, sameAsVideoAnc:values.sameAsVideoAnc,rtpPayLoadType: values.rtpPayLoadTypeAnc} :
            data.anc = {redundancy: values.redundancyAnc,
                        ttl: values.ttlAnc,
                        multicast: values.multicastAnc,
                        multicast2: values.multicastAnc2,
                        destinations: values.destinationsAnc.map(destination => `${destination.host}:${destination.port}`).join(','),
                        destinations2: values.destinationsAnc2.map(destination => `${destination.host}:${destination.port}`).join(','),
                        iface: values.ifaceAnc,
                        iface2: values.ifaceAnc2,
                        sameAsVideoAnc: values.sameAsVideoAnc,
                        rtpPayLoadType: values.rtpPayLoadTypeAnc,
                      };
          const  {redundancyVideo,redundancyAudio,ttlVideo,ttlAudio,multicastVideo,multicastVideo2,multicastAudio,multicastAudio2,destinationsVideo,destinationsVideo2,destinationsAudio,destinationsAudio2,ifaceVideo,ifaceVideo2,ifaceAudio,ifaceAudio2,sameAsVideo, rtpPayLoadTypeAudio, rtpPayLoadTypeVideo, 
                redundancyAnc,ttlAnc,multicastAnc,multicastAnc2,destinationsAnc,destinationsAnc2,ifaceAnc,ifaceAnc2,sameAsVideoAnc,rtpPayLoadTypeAnc,pTime,
                ...rest}= data;
          this.props.onSubmit(rest);
          resetForm(values);
          this.props.closeModal();
        
      }

      destinationValidation(dest, values, errors, mult){
        // Destinations
          values[dest].forEach((destination, index) => {
          if(isEmptyString(destination.host)){
            if(!errors[dest]){
              errors[dest] = [];
            }
            if(!errors[dest][index]){
              errors[dest][index] = {};
            }
            errors[dest][index].host = 'genericLabel.REQUIRED_FIELD.text';
          }
                // Multicast address
          let multicastRegex = /^2(?:2[4-9]|3\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d?|0)){3}$/;
          let ipRegex = /\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\b/;
          let validMulticastAddress = true;

          // Invalid multicast IP
          if (destination.host && values[mult] && !multicastRegex.test(destination.host)) {
            validMulticastAddress = false;
          }
          // Invalid unicast IP (should not be a mutlicast IP)
          else if (destination.host && !values[mult] && (!ipRegex.test(destination.host) || multicastRegex.test(destination.host))) {
            validMulticastAddress = false;
          }

          if (!validMulticastAddress) {
            if(!errors[dest]){
              errors[dest] = [];
            }
            if(!errors[dest][index]){
              errors[dest][index] = {};
            }
            errors[dest][index].host = 'genericLabel.INVALID_IP_ADDRESS.text';
          }

          if(isEmptyString(destination.port)){
            if(!errors[dest]){
              errors[dest] = [];
            }
            if(!errors[dest][index]){
              errors[dest][index] = {};
            }
            errors[dest][index].port = 'genericLabel.REQUIRED_FIELD.text';
          } else if (destination.port < PORT_MIN || destination.port > PORT_MAX) {
            if(!errors[dest]){
              errors[dest] = [];
            }
            if(!errors[dest][index]){
              errors[dest][index] = {};
            }
            errors[dest][index].port = 'genericLabel.INVALID_FORMAT.text';
          }
        });
        return errors;
  }

    render(){

        const props = this.props;
        const {translate, config, outputStatus, outputStandards, lostStreamModes, outputId } = props;    

       const handleValidation = (values)=>{
          const errors = {};
          //Name
          if (isEmptyString(values.name)) {
            errors.name = 'genericLabel.REQUIRED_FIELD.text';
          }
          else if(this.props.forbiddenNames.indexOf(values.name) !== -1){
            errors.name = 'genericLabel.DUPLICATED_VALUES.text';
          }
      
          //SMPTE
          if(this.props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX){
            //Destinations & iface
            this.destinationValidation('destinationsVideo', values, errors,'multicastVideo');
            if(isEmptyString(values.ifaceVideo)) {
              errors.ifaceVideo = 'genericLabel.REQUIRED_FIELD.text';
            }
            if(values.redundancyVideo){
              this.destinationValidation('destinationsVideo2',values,errors,'multicastVideo2');
              if(isEmptyString(values.ifaceVideo2)) {
                errors.ifaceVideo2 = 'genericLabel.REQUIRED_FIELD.text';
              }
            };
            if(!values.sameAsVideo){
              this.destinationValidation('destinationsAudio',values,errors,'multicastAudio');
              if(isEmptyString(values.ifaceAudio)) {
                errors.ifaceAudio = 'genericLabel.REQUIRED_FIELD.text';
              }
              if (values.redundancyAudio){
                this.destinationValidation('destinationsAudio2',values,errors,'multicastAudio2');
                if(isEmptyString(values.ifaceAudio2)) {
                  errors.ifaceAudio2 = 'genericLabel.REQUIRED_FIELD.text';
                }
              }
            }
            if(!values.sameAsVideoAnc && values.ancEnable){
              this.destinationValidation('destinationsAnc',values,errors,'multicastAnc');
              if(isEmptyString(values.ifaceAnc)) {
                errors.ifaceAnc = 'genericLabel.REQUIRED_FIELD.text';
              }
              if (values.redundancyAnc){
                this.destinationValidation('destinationsAnc2',values,errors,'multicastAnc2');
                if(isEmptyString(values.ifaceAnc2)) {
                  errors.ifaceAnc2 = 'genericLabel.REQUIRED_FIELD.text';
                }
              }
            }
            if(isEmptyString(values.rtpPayLoadTypeVideo)){
              errors.rtpPayLoadTypeVideo = 'genericLabel.REQUIRED_FIELD.text';
            }
          }
          return errors;
        };

        const defaultiFace = (iface)=>{
            var iface2=null;
            props.smpteIps.forEach(standard => {
              if(standard!==iface){
                iface2=standard
              }
            });
            return props.smpteIps.length<2 ? iface : iface2;
          };
          
          const handleChangeIface = (e,field,setFieldValue)=>{
            setFieldValue(field, e.target.value);
            props.smpteIps.forEach(standard => {
              if(standard!==e.target.value){
                setFieldValue(field+2, standard);
              }
            });
          };
          
          const defaultTTL = (multicast) => {
        if(multicast == null) {
          multicast = false;
        }
        return multicast ? 1 : 64;
      };

        const handleMulticastChange = (e, destination, setFieldValue, mutlname, ttlname) => {
            const multicastValue = e.target.checked;
            setFieldValue(mutlname, multicastValue);
            //setFieldValue('ttl', multicastValue ? 1 : 64);
            if(multicastValue && (mutlname==='multicastVideo' || mutlname==='multicastAudio' || mutlname==='multicastAnc') ){
            setFieldValue(ttlname, 1);
            //setFieldValue(destination, destination.filter((dest, index) => index === 0));
            }
            else if(mutlname==='multicastVideo' || mutlname==='multicastAudio' || mutlname==='multicastAnc'){
            setFieldValue(ttlname, 64);
            }
        };

        const handleSAVChange = (e, values, setFieldValue) => {
            const SAVValue = e.target.checked;
            setFieldValue('sameAsVideo', SAVValue)
            if (SAVValue){
              setFieldValue('multicastAudio', values.multicastVideo);
              setFieldValue('multicastAudio2', values.multicastVideo2);
              setFieldValue('redundancyAudio', values.redundancyVideo);
              setFieldValue('ttlAudio', values.ttlVideo);
              setFieldValue('destinationsAudio', values.destinationsVideo);
              setFieldValue('destinationsAudio2', values.destinationsVideo2);
              setFieldValue('ifaceAudio', values.ifaceVideo);
              setFieldValue('ifaceAudio2', values.ifaceVideo2);
            }
          };

          const handleSAVAncChange = (e, values, setFieldValue) => {
            const SAVValue = e.target.checked;
            setFieldValue('sameAsVideoAnc', SAVValue)
            if (SAVValue){
              setFieldValue('multicastAnc', values.multicastVideo);
              setFieldValue('multicastAnc2', values.multicastVideo2);
              setFieldValue('redundancyAnc', values.redundancyVideo);
              setFieldValue('ttlAnc', values.ttlVideo);
              setFieldValue('destinationsAnc', values.destinationsVideo);
              setFieldValue('destinationsAnc2', values.destinationsVideo2);
              setFieldValue('ifaceAnc', values.ifaceVideo);
              setFieldValue('ifaceAnc2', values.ifaceVideo2);
            }
          };

    return(
        <Formik initialValues={{
                name: config.name,
                outputStandard: config.outputStandard,
                sameAsInput: config.sameAsInput,
                lostStreamMode: `${config.lostStreamMode}`, // We transform to string here so that 'dirty' prop works
                lostPatternMode: `${config.lostPatternMode}`,
                enableDisplayName: config.enableDisplayName,
                
                //SMPTE2110 video settings
                multicastVideo: config.video ? config.video.multicast : false,
                ttlVideo: config.video && config.video.ttl != null ? config.video.ttl : defaultTTL(config.video ? config.video.multicast : null),
                destinationsVideo: config.video && config.video.destinations ? config.video.destinations.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceVideo: config.video ? config.video.iface : '',
                redundancyVideo: config.video? config.video.redundancy : false,

                multicastVideo2: config.video ? config.video.multicast2 : false,
                destinationsVideo2: config.video && config.video.destinations2 ? config.video.destinations2.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceVideo2: config.video ? defaultiFace(config.video.iface) : '',
                rtpPayLoadTypeVideo: config.video ? config.video.rtpPayLoadType : 96,

                //SMPTE2110 audio settings
                sameAsVideo: config.audio ? config.audio.sameAsVideo : true,
                multicastAudio: config.audio ? config.audio.multicast : false,
                ttlAudio: config.audio && config.audio.ttl != null ? config.audio.ttl : defaultTTL(config.audio ? config.audio.multicast : null),
                destinationsAudio: config.audio && config.audio.destinations ? config.audio.destinations.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceAudio: config.audio? config.audio.iface : '',
                redundancyAudio: config.audio ? config.audio.redundancy : false,
                multicastAudio2: config.audio ? config.audio.multicast2 : false,
                destinationsAudio2: config.audio && config.audio.destinations2 ? config.audio.destinations2.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceAudio2: config.audio ? defaultiFace(config.audio.iface) : '',
                rtpPayLoadTypeAudio: config.audio ? config.audio.rtpPayLoadType : 100,
                pTime: config.audio && config.audio.pTime ? config.audio.pTime : 1000,

                //SMPTE2110 anc settings
                ancEnable: config.ancEnable?? true,
                sameAsVideoAnc: config.anc ? config.anc.sameAsVideoAnc : true,
                multicastAnc: config.anc ? config.anc.multicast : false,
                ttlAnc: config.anc && config.anc.ttl != null ? config.anc.ttl : defaultTTL(config.anc ? config.anc.multicast : null),
                destinationsAnc: config.anc && config.anc.destinations ? config.anc.destinations.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceAnc: config.anc? config.anc.iface : '',
                redundancyAnc: config.anc ? config.anc.redundancy : false,
                multicastAnc2: config.anc ? config.anc.multicast2 : false,
                destinationsAnc2: config.anc && config.anc.destinations2 ? config.anc.destinations2.split(',').map(destination => {
                  return { host: destination.split(':')[0], port: destination.split(':')[1]
                  }}) :
                [{
                  host: '',
                  port: ''
                }],
                ifaceAnc2: config.anc ? defaultiFace(config.anc.iface) : '',
                rtpPayLoadTypeAnc: config.anc ? config.anc.rtpPayLoadType : 100,
                }}
              validate={handleValidation}
              validateOnBlur={false}
              validateOnChange={true}
              onSubmit={this.handleSubmit}>
            {({
            values,
            errors,
            dirty,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue
            /* and other goodies */
          }) => (
           <Form className="output-settings-form"
                 onSubmit={handleSubmit}>

          <HelpLayout filename="c_sh_2110_output_settings.html"
              form={<Fragment>

                {outputStatus !== STATUS_OFF &&
                <Alert color="warning">
                  <Translate id="genericLabel.WARNING_LOCAL_OUTPUT.text"/>
                </Alert>
                }
                {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && !props.licenceStatus &&
                <Alert color="danger">
                  <Translate id="genericLabel.STREAMHUB_LICENSE_SMPTE2110.text"/>
                </Alert>
                }

                <FormGroup>
                  <Label for="name">
                    <Translate id="genericLabel.NAME.text"/>
                  </Label>
                  <Input type="text"
                         required
                         name="name"
                         id="output_hardwareSetting_name"
                         invalid={errors.name !== undefined}
                         placeholder={translate("genericLabel.NAME.text")}
                         value={values.name}
                         onBlur={handleBlur}
                         onChange={handleChange}/>
                  <FormFeedback>
                    <Translate id={errors.name}/>
                  </FormFeedback>
                  <div className="indicator">
                    <Translate id={`genericLabel.NAME_DISPLAYED_ON_PREVIEW_AND_OUTPUT.text`}/>
                  </div>
                </FormGroup>

                <FormGroup>
                  <Label for="outputStandard">
                    <Translate id="genericLabel.OUTPUT_STANDARD.text"/>
                  </Label>
                  <Input type="select"
                         name="outputStandard"
                         id="output_hardwareSetting_outputStandard"
                         onBlur={handleBlur}
                         onChange={handleChange}
                         value={values.outputStandard}>
                    {outputStandards.map(standard => {
                      return <option key={standard} value={standard}>{standard}</option>
                    })}
                  </Input>
                </FormGroup>

                <FormGroup check>
                  <Label check>
                    <Input type="checkbox"
                           name="sameAsInput"
                           id="output_hardwareSetting_sameAsInput"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           checked={values.sameAsInput}/>{' '}
                    <Translate id="genericLabel.SAME_AS_CAMERA_VIDEO_STANDARD.text"/>
                  </Label>
                </FormGroup>

                {values.lostStreamMode !== 0 &&
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox"
                           name="enableDisplayName"
                           id="output_hardwareSetting_enableDisplayName"
                           onChange={handleChange}
                           checked={values.enableDisplayName}/>{' '}
                    <Translate id="genericLabel.DISPLAY_OUTPUT_NAME.text"/>
                  </Label>
                </FormGroup>
                }
                {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && <div>
                <AWHeading priority={6}>
                  <Translate id="genericLabel.VIDEO.text"/>
                </AWHeading>
                  {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceVideo)===-1 &&
                    <Alert color="warning">
                      <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                    </Alert>
                  }
                <Col>
                  <Row form>
                    <Col xs={6}>
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox"
                                name="multicastVideo"
                                id="output_hardwareSetting_enableMulticastVideo"
                                checked={values.multicastVideo}
                                onChange={ (e) => handleMulticastChange(e, values.destinationsVideo, setFieldValue, 'multicastVideo', 'ttlVideo')}
                                disabled={!props.licenceStatus}/>{' '}
                          <Translate id="genericLabel.MULTICAST.text"/>
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col xs={4}>
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox"
                                name="redundancyVideo"
                                id="output_hardwareSetting_enableredundancyVideo"
                                checked={values.redundancyVideo}
                                onChange={ handleChange}
                                disabled={ !props.licenceStatus  || (props.smpteIps.length<2 && !values.redundancyVideo)}/>{' '}
                          <Translate id="genericLabel.REDUNDANCY.text"/>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                <Row form>
                  <Col xs={6}>
                    <FormGroup>
                        <Label for="ifaceVideo">
                          <Translate id="genericLabel.INTERFACE.text"/>
                        </Label>
                        <Input type="select"
                              name="ifaceVideo"
                              id="output_hardwareSetting_ifaceVideo"
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeIface(e,'ifaceVideo',setFieldValue)}
                              value={values.ifaceVideo}
                              invalid={ getIn(errors, `ifaceVideo`) != null }
                              disabled={!props.licenceStatus}>
                          <option value=""></option>
                          {props.smpteIps.map(standard => {
                            return <option key={standard} value={standard}>{standard}</option>
                          })}
                        </Input>
                        <FormFeedback>
                          { getIn(errors, `ifaceVideo`) != null && <Translate id={errors.ifaceVideo}/> }
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col xs={4}>
                      <FormGroup>
                      <Label>
                        <Translate id="genericLabel.TTL.text">
                          TTL
                        </Translate>
                      </Label>
                      <Input type="number"
                            min="0"
                            max="64"
                            name="ttlVideo"
                            id="output_hardwareSetting_ttlVideo"
                            invalid={errors.ttlVideo !== undefined}
                            placeholder={ translate('genericLabel.TTL.text') }
                            value={values.ttlVideo}
                            onChange={handleChange}
                            disabled={!props.licenceStatus}/>
                      <FormFeedback>
                        <Translate id={errors.ttlVideo} />
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                  <FormGroup>
                    <Label>
                      <Translate id="genericLabel.DESTINATION.text" />
                    </Label>
                    <FieldArray name="destinationsVideo"
                                validateOnChange={false}>
                      {({ push, remove }) => {
                        return (
                          <Fragment>
                            { values.destinationsVideo.map((destination, index) => (
                              <Row key={index}
                                  className="destination-row"
                                  form>
                                <Col xs={6}>
                                  <FormGroup>
                                    <Input type="text"
                                          invalid={ getIn(errors, `destinationsVideo[${index}].host`) != null }
                                          name={`destinationsVideo[${index}].host`}
                                          id={"output_hardwareSetting_desinationsVideo_"+index}
                                          onChange={handleChange}
                                          placeholder={ translate('genericLabel.HOST.text') }
                                          value={values.destinationsVideo[index].host}
                                          disabled={!props.licenceStatus}/>
                                    <FormFeedback>
                                      { getIn(errors, `destinationsVideo[${index}].host`) != null && <Translate id={errors.destinationsVideo[index].host}/> }
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col xs={4}>
                                  <FormGroup>
                                    <Input type="number"
                                          invalid={ getIn(errors, `destinationsVideo[${index}].port`) != null }
                                          name={`destinationsVideo[${index}].port`}
                                          min={PORT_MIN}
                                          max={PORT_MAX}
                                          id={"output_hardwareSetting_portsVideo_"+index}
                                          onChange={handleChange}
                                          placeholder={ translate('genericLabel.PORT.text') }
                                          value={values.destinationsVideo[index].port}
                                          disabled={!props.licenceStatus}/>
                                    <FormFeedback>
                                      { getIn(errors, `destinationsVideo[${index}].port`) != null && <Translate id={errors.destinationsVideo[index].port}/> }
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                </Row>
                            ))}
                              { errors.destinationsGlobal &&
                              <div className="form-error">
                                <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                              </div>
                            }
                          </Fragment>
                        )}}
                    </FieldArray>
                  </FormGroup>
                  {values.redundancyVideo &&
                    <div>
                      <Label className="label warning">
                        <Translate id="genericLabel.REDUNDANCY_SETTINGS.text"/>
                      </Label>
                  {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceVideo2)===-1 &&
                    <Alert color="warning">
                      <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                    </Alert>
                  }
                      <FormGroup check>
                  <Label check>
                    <Input type="checkbox"
                          name="multicastVideo2"
                          id="output_hardwareSetting_enableMulticastVideo2"
                          checked={values.multicastVideo2}
                          onChange={ (e) => handleMulticastChange(e, values.destinationsVideo2, setFieldValue, 'multicastVideo2', 'ttlVideo')}
                          disabled={!props.licenceStatus || props.smpteIps.length<2}/>{' '}
                    <Translate id="genericLabel.MULTICAST.text"/>
                  </Label>
                </FormGroup>
                <Row form>
                  <Col xs={6}>
                    <FormGroup>
                        <Label for="ifaceVideo2">
                          <Translate id="genericLabel.INTERFACE.text"/>
                        </Label>
                        <Input type="select"
                              name="ifaceVideo2"
                              id="output_hardwareSetting_ifaceVideo2"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.ifaceVideo2}
                              disabled
                              invalid={ getIn(errors, `ifaceVideo2`) != null }>
                              <option value=""></option>
                              {props.smpteIps.map(standard => {
                                return <option key={standard} value={standard}>{standard}</option>
                              })}
                        </Input>
                        <FormFeedback>
                          { getIn(errors, `ifaceVideo2`) != null && <Translate id={errors.ifaceVideo2}/> }
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                </Row>
                  <FormGroup>
                    <Label>
                      <Translate id="genericLabel.DESTINATION.text" />
                    </Label>
                    <FieldArray name="destinationsVideo2"
                                validateOnChange={false}>
                      {({ push, remove }) => {
                        return (
                          <Fragment>
                            { values.destinationsVideo2.map((destination, index) => (
                              <Row key={index}
                                  className="destination-row"
                                  form>
                                <Col xs={6}>
                                  <FormGroup>
                                    <Input type="text"
                                          invalid={ getIn(errors, `destinationsVideo2[${index}].host`) != null }
                                          name={`destinationsVideo2[${index}].host`}
                                          id={"output_hardwareSetting_destinationsVideo2_"+index}
                                          onChange={handleChange}
                                          placeholder={ translate('genericLabel.HOST.text') }
                                          value={values.destinationsVideo2[index].host}
                                          disabled={!props.licenceStatus || props.smpteIps.length<2}/>
                                    <FormFeedback>
                                      { getIn(errors, `destinationsVideo2[${index}].host`) != null && <Translate id={errors.destinationsVideo2[index].host}/> }
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col xs={4}>
                                  <FormGroup>
                                    <Input type="number"
                                          invalid={ getIn(errors, `destinationsVideo2[${index}].port`) != null }
                                          name={`destinationsVideo2[${index}].port`}
                                          id={"output_hardwareSetting_portsVideo2_"+index}
                                          min={PORT_MIN}
                                          max={PORT_MAX}
                                          onChange={handleChange}
                                          placeholder={ translate('genericLabel.PORT.text') }
                                          value={values.destinationsVideo2[index].port}
                                          disabled={!props.licenceStatus || props.smpteIps.length<2}/>
                                    <FormFeedback>
                                      { getIn(errors, `destinationsVideo2[${index}].port`) != null && <Translate id={errors.destinationsVideo2[index].port}/> }
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                </Row>
                            ))}
                              { errors.destinationsGlobal &&
                              <div className="form-error">
                                <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                              </div>
                            }
                          </Fragment>
                        )}}
                    </FieldArray>
                  </FormGroup>
                    </div>
                  }
                  <Row form>
                    <Col xs={10}>
                      <FormGroup>
                          <Label>
                             <Translate id="genericLabel.RTP_PAYLOAD_TYPE.text"/>
                          </Label>
                          <Input type="number"
                                min="96"
                                max="127"
                                name="rtpPayLoadTypeVideo"
                                id="output_hardwareSetting_rtpPayLoadTypeVideo"
                                invalid={errors.rtpPayLoadTypeVideo !== undefined}
                                placeholder={ "rtp Payload Type" }
                                value={values.rtpPayLoadTypeVideo}
                                onChange={handleChange}
                                disabled={!props.licenceStatus}/>
                          <FormFeedback>
                            <Translate id={errors.rtpPayLoadTypeVideo} />
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                </Col>

                <AWHeading priority={6}>
                <Translate id="genericLabel.AUDIO.text"/>
              </AWHeading>
              {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceAudio)===-1 && !values.sameAsVideo &&
                <Alert color="warning">
                  <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                </Alert>
              }
              <Col>
                <Row form>
                  <Col xs={4}>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                              name="sameAsVideo"
                              id="output_hardwareSetting_sameAsVideo"
                              checked={values.sameAsVideo}
                              onChange={(e) => handleSAVChange(e,values, setFieldValue)}
                              disabled={!props.licenceStatus}/>{' '}
                        <Translate id="genericLabel.SAME_AS_VIDEO.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col xs={3}>
                    <FormGroup check
                               hidden={values.sameAsVideo}>
                      <Label check>
                        <Input type="checkbox"
                              name="multicastAudio"
                              id="output_hardwareSetting_enableMulticastAudio"
                              checked={values.multicastAudio}
                              onChange={ (e) => handleMulticastChange(e, values.destinationsAudio, setFieldValue, 'multicastAudio','ttlAudio')}
                              disabled={values.sameAsVideo || !props.licenceStatus}/>{' '}
                        <Translate id="genericLabel.MULTICAST.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col xs={3}>
                    <FormGroup check
                               hidden={values.sameAsVideo}>
                      <Label check>
                        <Input type="checkbox"
                              name="redundancyAudio"
                              id="output_hardwareSetting_enableRedundancyAudio"
                              checked={values.redundancyAudio}
                              onChange={ handleChange}
                              disabled={!props.licenceStatus || (props.smpteIps.length<2 && !values.redundancyAudio)}/>{' '}
                        <Translate id="genericLabel.REDUNDANCY.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              <Row form>
                <Col xs={6}>
                  <FormGroup hidden={values.sameAsVideo}>
                      <Label for="ifaceAudio">
                        Interface
                      </Label>
                      <Input type="select"
                            name="ifaceAudio"
                            id="output_hardwareSetting_ifaceAudio"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeIface(e,'ifaceAudio',setFieldValue)}
                            value={values.ifaceAudio}
                            disabled={values.sameAsVideo || !props.licenceStatus}
                            invalid={ getIn(errors, `ifaceAudio`) != null }>
                            <option value=""></option>
                        {props.smpteIps.map(standard => {
                          return <option key={standard} value={standard}>{standard}</option>
                        })}
                      </Input>
                      <FormFeedback>
                          { getIn(errors, `ifaceAudio`) != null && <Translate id={errors.ifaceAudio}/> }
                        </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col xs={4}>
                    <FormGroup hidden={values.sameAsVideo}>
                    <Label>
                      <Translate id="genericLabel.TTL.text">
                        TTL
                      </Translate>
                    </Label>
                    <Input type="number"
                           min="0"
                           max="64"
                           name="ttlAudio"
                          id="output_hardwareSetting_ttlAudio"
                           invalid={errors.ttlAudio !== undefined}
                           placeholder={ translate('genericLabel.TTL.text') }
                           value={values.ttlAudio}
                           onChange={handleChange}
                           disabled={values.sameAsVideo || !props.licenceStatus}/>
                    <FormFeedback>
                      <Translate id={errors.ttlAudio} />
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
                <FormGroup hidden={values.sameAsVideo}>
                  <Label>
                    <Translate id="genericLabel.DESTINATION.text" />
                  </Label>
                  <FieldArray name="destinationsAudio"
                              validateOnChange={false}>
                    {({ push, remove }) => {
                      return (
                        <Fragment>
                          { values.destinationsAudio.map((destination, index) => (
                            <Row key={index}
                                className="destination-row"
                                form>
                              <Col xs={6}>
                                <FormGroup>
                                  <Input type="text"
                                        invalid={ getIn(errors, `destinationsAudio[${index}].host`) != null }
                                        name={`destinationsAudio[${index}].host`}
                                        id={"output_hardwareSetting_destinationsAudio"+index}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.HOST.text') }
                                        value={values.destinationsAudio[index].host}
                                        disabled={values.sameAsVideo || !props.licenceStatus}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAudio[${index}].host`) != null && <Translate id={errors.destinationsAudio[index].host}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col xs={4}>
                                <FormGroup>
                                  <Input type="number"
                                        invalid={ getIn(errors, `destinationsAudio[${index}].port`) != null }
                                        name={`destinationsAudio[${index}].port`}
                                        id={"output_hardwareSetting_portsAudio"+index}
                                        min={PORT_MIN}
                                        max={PORT_MAX}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.PORT.text') }
                                        value={values.destinationsAudio[index].port}
                                        disabled={values.sameAsVideo || !props.licenceStatus}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAudio[${index}].port`) != null && <Translate id={errors.destinationsAudio[index].port}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              </Row>
                          ))}
                            { errors.destinationsGlobal &&
                            <div className="form-error">
                              <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                            </div>
                          }
                        </Fragment>
                      )}}
                  </FieldArray>
                </FormGroup>
                {values.redundancyAudio && !values.sameAsVideo &&
                  <div>
                    <Label className="label warning">
                      <Translate id="genericLabel.REDUNDANCY_SETTINGS.text"/>
                    </Label>
                    {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceAudio2)===-1 &&
                      <Alert color="warning">
                        <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                      </Alert>
                    }
                    <FormGroup check>
                <Label check>
                  <Input type="checkbox"
                        name="multicastAudio2"
                        id="output_hardwareSetting_enableMulticastAudio2"
                        checked={values.multicastAudio2}
                        onChange={ (e) => handleMulticastChange(e, values.destinationsAudio2, setFieldValue, 'multicastAudio2','ttlAudio')}
                        disabled={values.sameAsVideo || !props.licenceStatus || props.smpteIps.length<2}/>{' '}
                  <Translate id="genericLabel.MULTICAST.text"/>
                </Label>
              </FormGroup>
              <Row form>
                <Col xs={6}>
                  <FormGroup>
                      <Label for="ifaceAudio2">
                       <Translate id="genericLabel.INTERFACE.text"/>
                      </Label>
                      <Input type="select"
                            name="ifaceAudio2"
                            id="output_hardwareSetting_ifaceAudio2"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.ifaceAudio2}
                            disabled
                            invalid={ getIn(errors, `ifaceAudio2`) != null }>
                            <option value=""></option>
                            {props.smpteIps.map(standard => {
                              return <option key={standard} value={standard}>{standard}</option>
                            })}
                      </Input>
                      <FormFeedback>
                          { getIn(errors, `ifaceAudio2`) != null && <Translate id={errors.ifaceAudio2}/> }
                        </FormFeedback>
                    </FormGroup>
                  </Col>
              </Row>
                <FormGroup>
                  <Label>
                    <Translate id="genericLabel.DESTINATION.text" />
                  </Label>
                  <FieldArray name="destinationsAudio2"
                              validateOnChange={false}>
                    {({ push, remove }) => {
                      return (
                        <Fragment>
                          { values.destinationsAudio2.map((destination, index) => (
                            <Row key={index}
                                className="destination-row"
                                form>
                              <Col xs={6}>
                                <FormGroup>
                                  <Input type="text"
                                        invalid={ getIn(errors, `destinationsAudio2[${index}].host`) != null }
                                        name={`destinationsAudio2[${index}].host`}
                                        id={"output_hardwareSetting_destinationsAudio2_"+index}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.HOST.text') }
                                        value={values.destinationsAudio2[index].host}
                                        disabled={values.sameAsVideo || !props.licenceStatus || props.smpteIps.length<2}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAudio2[${index}].host`) != null && <Translate id={errors.destinationsAudio2[index].host}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col xs={4}>
                                <FormGroup>
                                  <Input type="number"
                                        invalid={ getIn(errors, `destinationsAudio2[${index}].port`) != null }
                                        name={`destinationsAudio2[${index}].port`}
                                        id={"output_hardwareSetting_portsAudio2_"+index}
                                        min={PORT_MIN}
                                        max={PORT_MAX}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.PORT.text') }
                                        value={values.destinationsAudio2[index].port}
                                        disabled={values.sameAsVideo || !props.licenceStatus || props.smpteIps.length<2}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAudio2[${index}].port`) != null && <Translate id={errors.destinationsAudio2[index].port}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              </Row>
                          ))}
                            { errors.destinationsGlobal &&
                            <div className="form-error">
                              <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                            </div>
                          }
                        </Fragment>
                      )}}
                  </FieldArray>
                </FormGroup>
                  </div>
                }
                <Row form>
                    <Col xs={10}>
                      <FormGroup>
                          <Label>
                            <Translate id="genericLabel.RTP_PAYLOAD_TYPE.text"/>
                          </Label>
                          <Input type="number"
                                min="96"
                                max="127"
                                name="rtpPayLoadTypeAudio"
                                id="output_hardwareSetting_rtpPayLoadTypeVideo"
                                invalid={errors.rtpPayLoadTypeAudio !== undefined}
                                placeholder={ "rtp Payload Type" }
                                value={values.rtpPayLoadTypeAudio}
                                onChange={handleChange}
                                disabled={!props.licenceStatus}/>
                          <FormFeedback>
                            <Translate id={errors.rtpPayLoadTypeAudio} />
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                    <Col xs={10}>
                    <FormGroup>
                    <Label for="pTime">
                      Packet Time
                    </Label>
                    <Input type="select"
                          name="pTime"
                          id="output_hardwareSetting_rtpPayLoadTypeVideo"
                          value={values.pTime}
                          disabled={!props.licenceStatus}
                          onChange={handleChange}>
                      <option value={1000} id="1ms">1ms</option>
                      <option value={125} id="0.125ms">0.125ms</option>
                    </Input>
                </FormGroup></Col></Row>
              </Col>

              <AWHeading priority={6}>
                <Translate id="genericLabel.ANC.text"/>
              </AWHeading>
              {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceAnc)===-1 && !!values.ancEnable && !values.sameAsVideoAnc &&
                <Alert color="warning">
                  <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                </Alert>
              }
              <Col>
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox"
                          name="ancEnable"
                          id="output_hardwareSetting_ancEnable"
                          checked={values.ancEnable}
                          onChange={handleChange}
                          disabled={!props.licenceStatus}/>{' '}
                    Enable ancillary data{/* <Translate id="genericLabel.SAME_AS_VIDEO.text"/> */}
                  </Label>
                </FormGroup>
              </Col>
              {values.ancEnable && <><Col>
                <Row form>
                  <Col xs={4}>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                              name="sameAsVideoAnc"
                              id="output_hardwareSetting_sameAsVideoAnc"
                              checked={values.sameAsVideoAnc}
                              onChange={(e) => handleSAVAncChange(e,values, setFieldValue)}
                              disabled={!props.licenceStatus}/>{' '}
                        <Translate id="genericLabel.SAME_AS_VIDEO.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col xs={3}>
                    <FormGroup check
                               hidden={values.sameAsVideoAnc}>
                      <Label check>
                        <Input type="checkbox"
                              name="multicastAnc"
                              id="output_hardwareSetting_enableMulticastAnc"
                              checked={values.multicastAnc}
                              onChange={ (e) => handleMulticastChange(e, values.destinationsAnc, setFieldValue, 'multicastAnc','ttlAnc')}
                              disabled={values.sameAsVideoAnc || !props.licenceStatus}/>{' '}
                        <Translate id="genericLabel.MULTICAST.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col xs={3}>
                    <FormGroup check
                               hidden={values.sameAsVideoAnc}>
                      <Label check>
                        <Input type="checkbox"
                              name="redundancyAnc"
                              id="output_hardwareSetting_enableRedundancyAnc"
                              checked={values.redundancyAnc}
                              onChange={ handleChange}
                              disabled={!props.licenceStatus || (props.smpteIps.length<2 && !values.redundancyAnc)}/>{' '}
                        <Translate id="genericLabel.REDUNDANCY.text"/>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              <Row form>
                <Col xs={6}>
                  <FormGroup hidden={values.sameAsVideoAnc}>
                      <Label for="ifaceAnc">
                        Interface
                      </Label>
                      <Input type="select"
                            name="ifaceAnc"
                            id="output_hardwareSetting_ifaceAnc"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeIface(e,'ifaceAnc',setFieldValue)}
                            value={values.ifaceAnc}
                            disabled={values.sameAsVideoAnc || !props.licenceStatus}
                            invalid={ getIn(errors, `ifaceAnc`) != null }>
                            <option value=""></option>
                        {props.smpteIps.map(standard => {
                          return <option key={standard} value={standard}>{standard}</option>
                        })}
                      </Input>
                      <FormFeedback>
                          { getIn(errors, `ifaceAnc`) != null && <Translate id={errors.ifaceAnc}/> }
                        </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col xs={4}>
                    <FormGroup hidden={values.sameAsVideoAnc}>
                    <Label>
                      <Translate id="genericLabel.TTL.text">
                        TTL
                      </Translate>
                    </Label>
                    <Input type="number"
                           min="0"
                           max="64"
                           name="ttlAnc"
                          id="output_hardwareSetting_ttlAnc"
                           invalid={errors.ttlAnc !== undefined}
                           placeholder={ translate('genericLabel.TTL.text') }
                           value={values.ttlAnc}
                           onChange={handleChange}
                           disabled={values.sameAsVideoAnc || !props.licenceStatus}/>
                    <FormFeedback>
                      <Translate id={errors.ttlAnc} />
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
                <FormGroup hidden={values.sameAsVideoAnc}>
                  <Label>
                    <Translate id="genericLabel.DESTINATION.text" />
                  </Label>
                  <FieldArray name="destinationsAnc"
                              validateOnChange={false}>
                    {({ push, remove }) => {
                      return (
                        <Fragment>
                          { values.destinationsAnc.map((destination, index) => (
                            <Row key={index}
                                className="destination-row"
                                form>
                              <Col xs={6}>
                                <FormGroup>
                                  <Input type="text"
                                        invalid={ getIn(errors, `destinationsAnc[${index}].host`) != null }
                                        name={`destinationsAnc[${index}].host`}
                                        id={"output_hardwareSetting_destinationsAnc"+index}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.HOST.text') }
                                        value={values.destinationsAnc[index].host}
                                        disabled={values.sameAsVideoAnc || !props.licenceStatus}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAnc[${index}].host`) != null && <Translate id={errors.destinationsAnc[index].host}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col xs={4}>
                                <FormGroup>
                                  <Input type="number"
                                        invalid={ getIn(errors, `destinationsAnc[${index}].port`) != null }
                                        name={`destinationsAnc[${index}].port`}
                                        id={"output_hardwareSetting_portsAnc"+index}
                                        min={PORT_MIN}
                                        max={PORT_MAX}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.PORT.text') }
                                        value={values.destinationsAnc[index].port}
                                        disabled={values.sameAsVideoAnc || !props.licenceStatus}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAnc[${index}].port`) != null && <Translate id={errors.destinationsAnc[index].port}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              </Row>
                          ))}
                            { errors.destinationsGlobal &&
                            <div className="form-error">
                              <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                            </div>
                          }
                        </Fragment>
                      )}}
                  </FieldArray>
                </FormGroup>
                {values.redundancyAnc && !values.sameAsVideoAnc &&
                  <div>
                    <Label className="label warning">
                      <Translate id="genericLabel.REDUNDANCY_SETTINGS.text"/>
                    </Label>
                    {props.videoCard.sdiCardType===VIDEO_CARD_TYPE_RIVERMAX && props.smpteIps.indexOf(values.ifaceAnc2)===-1 &&
                      <Alert color="warning">
                        <Translate id="genericLabel.INVALID_INTERFACE.text"/>
                      </Alert>
                    }
                    <FormGroup check>
                <Label check>
                  <Input type="checkbox"
                        name="multicastAnc2"
                        id="output_hardwareSetting_enableMulticastAnc2"
                        checked={values.multicastAnc2}
                        onChange={ (e) => handleMulticastChange(e, values.destinationsAnc2, setFieldValue, 'multicastAnc2','ttlAnc')}
                        disabled={values.sameAsVideoAnc || !props.licenceStatus || props.smpteIps.length<2}/>{' '}
                  <Translate id="genericLabel.MULTICAST.text"/>
                </Label>
              </FormGroup>
              <Row form>
                <Col xs={6}>
                  <FormGroup>
                      <Label for="ifaceAnc2">
                       <Translate id="genericLabel.INTERFACE.text"/>
                      </Label>
                      <Input type="select"
                            name="ifaceAnc2"
                            id="output_hardwareSetting_ifaceAnc2"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.ifaceAnc2}
                            disabled
                            invalid={ getIn(errors, `ifaceAnc2`) != null }>
                            <option value=""></option>
                            {props.smpteIps.map(standard => {
                              return <option key={standard} value={standard}>{standard}</option>
                            })}
                      </Input>
                      <FormFeedback>
                          { getIn(errors, `ifaceAnc2`) != null && <Translate id={errors.ifaceAnc2}/> }
                        </FormFeedback>
                    </FormGroup>
                  </Col>
              </Row>
                <FormGroup>
                  <Label>
                    <Translate id="genericLabel.DESTINATION.text" />
                  </Label>
                  <FieldArray name="destinationsAnc2"
                              validateOnChange={false}>
                    {({ push, remove }) => {
                      return (
                        <Fragment>
                          { values.destinationsAnc2.map((destination, index) => (
                            <Row key={index}
                                className="destination-row"
                                form>
                              <Col xs={6}>
                                <FormGroup>
                                  <Input type="text"
                                        invalid={ getIn(errors, `destinationsAnc2[${index}].host`) != null }
                                        name={`destinationsAnc2[${index}].host`}
                                        id={"output_hardwareSetting_destinationsAnc2_"+index}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.HOST.text') }
                                        value={values.destinationsAnc2[index].host}
                                        disabled={values.sameAsVideoAnc || !props.licenceStatus || props.smpteIps.length<2}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAnc2[${index}].host`) != null && <Translate id={errors.destinationsAnc2[index].host}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col xs={4}>
                                <FormGroup>
                                  <Input type="number"
                                        invalid={ getIn(errors, `destinationsAnc2[${index}].port`) != null }
                                        name={`destinationsAnc2[${index}].port`}
                                        id={"output_hardwareSetting_portsAnc2_"+index}
                                        min={PORT_MIN}
                                        max={PORT_MAX}
                                        onChange={handleChange}
                                        placeholder={ translate('genericLabel.PORT.text') }
                                        value={values.destinationsAnc2[index].port}
                                        disabled={values.sameAsVideoAnc || !props.licenceStatus || props.smpteIps.length<2}/>
                                  <FormFeedback>
                                    { getIn(errors, `destinationsAnc2[${index}].port`) != null && <Translate id={errors.destinationsAnc2[index].port}/> }
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              </Row>
                          ))}
                            { errors.destinationsGlobal &&
                            <div className="form-error">
                              <Translate id={errors.destinationsGlobal} /> { errors.duplicateUriFrom }
                            </div>
                          }
                        </Fragment>
                      )}}
                  </FieldArray>
                </FormGroup>
                  </div>
                }
                <Row form>
                    <Col xs={10}>
                      <FormGroup>
                          <Label>
                            <Translate id="genericLabel.RTP_PAYLOAD_TYPE.text"/>
                          </Label>
                          <Input type="number"
                                min="96"
                                max="127"
                                name="rtpPayLoadTypeAnc"
                                id="output_hardwareSetting_rtpPayLoadTypeVideo"
                                invalid={errors.rtpPayLoadTypeAnc !== undefined}
                                placeholder={ "rtp Payload Type" }
                                value={values.rtpPayLoadTypeAnc}
                                onChange={handleChange}
                                disabled={!props.licenceStatus}/>
                          <FormFeedback>
                            <Translate id={errors.rtpPayLoadTypeAnc} />
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
              </Col></>}
            </div>}
                <FormGroup>
                  <Label for="lostStreamMode">
                    <Translate id="genericLabel.DEFAULT_VIDEO_PATTERN.text"/>
                  </Label>
                  <Input type="select"
                         name="lostStreamMode"
                         id="output_hardwareSetting_lostStreamMode"
                         onBlur={handleBlur}
                         onChange={(e) => {
                           handleChange(e);
                           if (parseInt(e.target.value) !== CUSTOM_PATTERN_VALUE && parseInt(values.lostPatternMode) !== CUSTOM_PATTERN_VALUE) {
                            this.handleCustomPattern(false);
                           }
                           else {
                             this.handleCustomPattern(true);
                           }
                         }}
                         value={values.lostStreamMode}>
                    {lostStreamModes.map(dest => {
                      return <option key={dest.value}
                                     value={dest.value}
                                     id={translate(`lostStreamMode.${dest.name}.text`)}>{translate(`lostStreamMode.${dest.name}.text`)}</option>
                    })}
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label for="lostPatternMode">
                    <Translate id="genericLabel.POLICY_VIDEO_PATTERN.text"/>
                  </Label>
                  <Input type="select"
                         name="lostPatternMode"
                         id="output_hardwareSetting_lostPatternMode"
                         onBlur={handleBlur}
                         onChange={(e) => {
                           handleChange(e);
                           if (parseInt(e.target.value) !== CUSTOM_PATTERN_VALUE && parseInt(values.lostStreamMode) !== CUSTOM_PATTERN_VALUE) {
                             this.handleCustomPattern(false);
                           }
                           else {
                             this.handleCustomPattern(true);
                           }
                         }}
                         value={values.lostPatternMode}>
                    {lostStreamModes.map(dest => {
                      return <option key={dest.value}
                                     value={dest.value}
                                     id={translate(`lostStreamMode.${dest.name}.text`)}>{translate(`lostStreamMode.${dest.name}.text`)}</option>
                    })}
                  </Input>
                </FormGroup>

                { this.state.customPatternFormVisible &&
                  <CustomPatternForm prefix={SETTINGS_OUTPUT_CUSTOM_PATTERN_PREFIX} id={outputId} timestamp={new Date().getTime()}/>
                }
                </Fragment>}

                buttons={
                  <FormGroup className="buttons">
                    <Button id="output_hardwareSetting_saveButton"
                            color="primary"
                            disabled={!dirty}
                            type="submit">
                      <Translate id="genericLabel.SAVE.text"/>
                    </Button>
                  </FormGroup>
                } />

            </Form>
          )}
      </Formik>
    );
    }
}

SMPTE2110Form.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
    const existingBasebandPlayerOutputNames = getBasebandPlayerOutputNames(state);
    return {
      outputStatus: state.streamhub.hardwareOutputs.find(output => output.id === ownProps.outputId).status,
      videoCard: outputMatchingVideoCard(getAvailableVideoCards(state), state.streamhub.hardwareOutputs.find(output => output.id === ownProps.outputId)),
      config: state.config.basebandPlayer[ownProps.outputId],
      lostStreamModes: getAvailableLostStreamModes(state),
      outputStandards: getAvailableHardwareOutputStandards(state, ownProps),
      forbiddenNames: existingBasebandPlayerOutputNames.filter(name => name !== state.config.basebandPlayer[ownProps.outputId].name),
      smpteIps: state.streamhub.smpteIps,
      localIps: state.streamhub.localIps,
      licenceStatus: state.streamhub.smpte2110[1] ? state.streamhub.smpte2110[0].allowed2110 : false,
    }
  };
  
  export default connect(mapStateToProps)(withLocalize(SMPTE2110Form));